// extracted by mini-css-extract-plugin
export default {"frame":"GalleryView_frame__FBnLu","icon":"GalleryView_icon__PSrN7","left":"GalleryView_left__uYbk+","right":"GalleryView_right__FKzdy"};